import React from 'react';

import Back from '../common/Back';

import style from './CoverageGuidePage.module.css';

const CoverageGuidePage = React.memo(() => {
  return (
    <div className={style.coverageGuide}>
      <Back path="/tools" text="Reference Tools" />
      <h1>Coverage Guide</h1>
      <section className={style.content}>
        <h2>Management Liability Coverage Overview</h2>
        <h3>Directors & Officers Liability</h3>
        <p>
          Directors, Officers, and Entity Liability Insurance (D&amp;O) is
          specifically designed to help protect the personal assets of a
          company’s directors and officers, as well as the financial well-being
          of the company itself. As leaders of the company, the directors and
          officers can be held personally liable for their management decisions.
          Shareholders, employees, investors, customers, competitors, creditors,
          vendors, suppliers and even the government can sue a company and its
          board. Common allegations against directors and officers include
          Breach of Duty of Care, Breach of Duty of Loyalty, Neglect,
          Misrepresentations, Defamation, Omissions, Misstatements and Errors.
        </p>
        <h3>Employment Practices Liability</h3>
        <p>
          Employment Practices Liability Insurance (EPL) is designed to protect
          the directors and officers, and most importantly, the company, for
          claims brought by current or former employees of the company or
          applicants for employment. Typically, these claims are for such
          employment-related torts as discrimination, harassment, wrongful
          termination and retaliation. Coverage can be included for domestic
          employees and 3rd party liability (claims brought by customers,
          clients, vendors).
        </p>
        <h3>Fiduciary Liability</h3>
        <p>
          Fiduciary Liability insures individual plan administrators, trustees,
          and Fiduciaries, as well as the corporation for claims arising out of
          the administration of and decisions associated with management of
          employee benefit plans and violations of ERISA.
        </p>
        <h3>Crime</h3>
        <p>
          Employee Theft or Crime provides coverage for direct losses sustained
          by the Insured Organization and its Subsidiaries from employee theft,
          or third parties on premises/in transit robbery and safe burglary,
          computer fraud, money order &amp; counterfeit currency.
        </p>
        <h2>
          Look for these Coverage Enhancements within your Small Business
          Management Liability Quote
        </h2>
        <h3>Common Terms & Conditions Section</h3>
        <ul>
          <li>Policy non-cancellable except for nonpayment of premium</li>
          <li>No Hammer Provision </li>
          <li>ERP options up to six years </li>
          <li>
            Knowledge of claim applies only when CEO or CFO become aware of a
            claim
          </li>
          <li>
            Conduct Exclusion is limited to Personal Profit and Financial
            Advantage
          </li>
        </ul>
        <h3>Directors, Officers & Corporate Liability</h3>
        <ul>
          <li>Antitrust coverage provided </li>
          <li>Derivative Investigation Costs sublimit </li>
          <li>Supplemental Side A – $1,000,000 </li>
          <li>Crisis Management Expense sublimit </li>
        </ul>
        <h3>Employment Practices Liability</h3>
        <ul>
          <li>Wage and Hour Defense sublimit </li>
          <li>Independent Contractors covered as employees </li>
          <li>Third Party Coverage included </li>
          <li>
            Affirmative coverage for defense costs for breach of employment
            contract
          </li>
          <li>Crisis Management Expense sublimit </li>
        </ul>
        <h3>Fiduciary Liability</h3>
        <ul>
          <li>Settlor Liability </li>
          <li>Voluntary Reporting Compliance sublimit </li>
          <li>
            Civil Fines and Penalties coverage for ERISA, IRS 4975, PPACA, PPA
            sublimit
          </li>
          <li>HIPAA fines/penalties sublimit </li>
          <li>Managed Care coverage with BI/PD carveback </li>
        </ul>
        <h3>Crime</h3>
        <ul>
          <li>Loss Discovered Form </li>
          <li>Coverage Extension for Client Property </li>
          <li>Social Engineering Fraud sublimit </li>
          <li>Investigation Expense sublimit </li>
          <li>Telephone Toll Fraud sublimit </li>
          <li>Tax Loss Compensation coverage for foreign crime claims </li>
        </ul>
        <br />
        <p>
          This material offers a brief description of coverages and coverage
          enhancements and is provided for informational purposes only. Actual
          coverages may vary by Insured and state. Some coverage options are not
          available in all states. Please refer to the carrier quote proposal
          for exact terms, conditions, exclusions, and limitations.{' '}
        </p>
      </section>
    </div>
  );
});

CoverageGuidePage.propTypes = {};

export default CoverageGuidePage;
